/** @jsxImportSource @emotion/react */
import React from "react";
import { ReactComponent as PasteIcon } from "../../../img/clipboard.svg";
import { pasteButtonStyle } from "../SwapAndSendStyle";
import { GlobalStore } from "../../../store/global/GlobalStore";

interface PasteAddressProps {
  visible: boolean;
  handlePaste: () => void;
}

export const PasteAddress: React.FC<PasteAddressProps> = ({ visible, handlePaste }) => {
  const theme = GlobalStore.useState(s => s.theme);

  if (!visible) {
    return null;
  }

  return (
    <button css={pasteButtonStyle} onClick={handlePaste}>
      <PasteIcon
        className="me-1"
        width="18"
        height="18"
        style={{ color: theme.button.primary.surface.active }}
      />{" "}
      Paste
    </button>
  );
};
